import { __rest } from "tslib";
import styled from '@emotion/styled';
import * as React from 'react';
import { Button } from '../button';
const paddingMap = {
    small: { padding: '0.375rem' },
    regular: {
        padding: '0.625rem',
    },
    large: { padding: '0.875rem' },
};
export const getStyles = (size) => (Object.assign({ borderRadius: '100%' }, paddingMap[size]));
const StyledButton = styled(Button) `
	${({ size }) => getStyles(size)}
`;
export const IconButton = (_a) => {
    var { size = 'regular', icon = 'Home' } = _a, props = __rest(_a, ["size", "icon"]);
    return React.createElement(StyledButton, Object.assign({ icon: icon, size: size }, props));
};
//# sourceMappingURL=IconButton.js.map